import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import useApi from "../../Hooks/useApi";
// import * as postapi from "../../api/postapi";
import * as api from "../../api/getapi";

import PlatformCommisionModal from "../../Components/PlatformCommision/PlatformCommisionModal";
import CustomizeTableview from "../../Components/TableViews/CustomizeTableview";

const PlatformCommision = () => {
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [mode, setMode] = useState("Add")
  const [selectedData, setSelectedData] = useState()

  const fetchPlatformCommision = useApi(api.fetchPlatformCommision, { hasCatchError: true });
  // const DeletePlatformCommision = useApi(postapi.DeletePaltformCommision, { hasCatchError: true });



  // const handleRemove = async (id) => {
  //   await DeletePlatformCommision.request(id);
  //   getPlatformCommision()


  // }

  function getPlatformCommision() {
    try {
      fetchPlatformCommision
        .request(
      )
        .then((res) => {
          setData(res?.data?.data);

        })
        .catch((err) => {
          const tempErr = err.response.data.error;

          if (tempErr.status === 404 && tempErr.message === "No Record Found") {
            // setVochers([]);
            setIsLoading(false);
          }
        });
    } catch (err) {
      const tempErr = err.response.data.error;

      if (tempErr.status === 404 && tempErr.message === "No Record Found") {
        // setVochers([]);
        setIsLoading(false);
      }
    }
  }

  useEffect(() => {
    getPlatformCommision();
  }, [modalShow]);



  return (
    <>
      <Button variant="primary" className="mb-3" onClick={() => { setData([]); setMode("Add"); setModalShow(true) }}>
        Add Commission +
      </Button >
      <CustomizeTableview data={data} isLoading={isLoading}


        columnNotShow={["id", "created_at", "updated_at", "deleted_at", "category_id", 'is_deleted']}
        edit={(data) => { setSelectedData(data); setModalShow(true); setMode("Edit") }}
      // remove={(data) => { handleRemove(data.id) }}

      // actionButton={}
      />
      <PlatformCommisionModal show={modalShow} setModalShow={setModalShow} selectedData={selectedData} mode={mode} refreshData={getPlatformCommision}
      />
      {/* 
      <Modal show={modalShow} onHide={() => setModalShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Platform Commission</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row className="gy-2 gx-3">
              {[<Form.Select
                size="sm"
                value={data.category.value}
                onChange={handleCategoryChange}
              >
                <option value="">Select Category</option>
                {categoryOptions.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Form.Select>,
              <Form.Control
                type="number"
                placeholder="Cap Amount"
                value={data.capAmount || ""}
                onChange={(e) =>
                  handleChange(
                    "capAmount",
                    e.target.value ? parseFloat(e.target.value) : ""
                  )
                }
              />,
              <Form.Select
                size="sm"
                value={data.comm_type_for_amount_lt_cap}
                onChange={(e) =>
                  handleChange("comm_type_for_amount_lt_cap", e.target.value)
                }
              >
                <option value="">Select Commission Type</option>
                {commTypeOptions.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Form.Select>,
              <Form.Control
                type="number"
                placeholder="Commission Value"
                value={data.comm_value_for_amount_lt_cap}
                onChange={(e) =>
                  handleChange(
                    "comm_value_for_amount_lt_cap",
                    e.target.value ? parseFloat(e.target.value) : ""
                  )
                }
                max={
                  data.comm_type_for_amount_lt_cap === "percentage" ? 100 : undefined
                }
              />,
              <Form.Select
                size="sm"
                value={data.comm_type_for_amount_gte_cap}
                onChange={(e) =>
                  handleChange("comm_type_for_amount_gte_cap", e.target.value)
                }
              >
                <option value="">Select Commission Type</option>
                {commTypeOptions.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Form.Select>,
              <Form.Control
                type="number"
                placeholder="Commission Value"
                value={data.comm_value_for_amount_gte_cap}
                onChange={(e) =>
                  handleChange(
                    "comm_value_for_amount_gte_cap",
                    e.target.value ? parseFloat(e.target.value) : ""
                  )
                }
                max={
                  data.comm_type_for_amount_gte_cap === "percentage" ? 100 : undefined
                }
              />

              ].map((field, index) => (
                <Col xs={12} md={6} key={index}>
                  {field}
                </Col>
              ))}
              <Button type="submit">Submit</Button>

            </Row>

          </Form>
        </Modal.Body>
      </Modal> */}
    </>
  );
};

export default PlatformCommision;
